import _ from 'lodash';
import React from 'react';
import FieldSelect from '../../../configuration/fields/FieldSelect';
import * as Row from '../../../layout/Row';
import GenerateDocumentationModalBase, { IGenDocModalBaseProps, IGenDocModalBaseState } from './GenerateDocumentationModalBase';
import { Calculation } from "../../../../../src/application/Contracts";
import TWSCalculationEditModel = Calculation.TWSCalculationEditModel;
import GenerateDocumentationModel = Calculation.GenerateDocumentationModel;
import DocumentationType = Calculation.DocumentationType;
import CalculationDocumentationModel = Calculation.CalculationDocumentationModel;

interface IGenDocModalProps extends IGenDocModalBaseProps {
    id: number
}

interface IGenDocModalState extends IGenDocModalBaseState {
    selectedOutcomes: any[],
    selectedDocumentations: any[],
    publicPriceInclude: boolean
}

export default class GenerateDocumentationsModal extends GenerateDocumentationModalBase<IGenDocModalProps, IGenDocModalState> {
    constructor(props: IGenDocModalProps) {
        super(props)
        this.state = {
            ...this.state,
            selectedOutcomes: [],
            selectedDocumentations: [],
            publicPriceInclude: false
        };
    }

    protected override getDocumentationModalContentData(): number {
        return this.props.id
    }

    protected override thenFetchModalData(response: any) {
        super.thenFetchModalData(response);

        this.setState({
            selectedDocumentations: response.data.documentations.value.map((d: CalculationDocumentationModel) => d.calculation.id)
        });
    }

    protected override getWidth(): string | null {
        return 'auto';
    }

    protected override getDocumentType(): DocumentationType {
        return DocumentationType.Project;
    }

    protected override renderBody(): React.ReactNode {
        const languages = this.state.isLoading ? [] : this.state.model.language.items
        return (
            <div className="project-documentation-modal">
                <div className="left">
                    <div className="text-muted" style={{ paddingBottom: '0.5rem' }}>{__('Substations')} </div>
                    <div style={{ padding: '4px 0', borderBottom: '1px solid #313551' }}>
                        <input id={`select-all-outcomes`} type="checkbox" checked={this.state.selectedOutcomes.length == this.state.model.twsOutcomes.items.length}
                            onChange={() => {
                                this.setState({
                                    selectedOutcomes: this.state.model.twsOutcomes.items.map((i: any) => i.value)
                                });
                            }} />
                        <label htmlFor={`select-all-outcomes`}>{__(`Select all`)}</label>
                    </div>
                    {this.state.model.twsOutcomes.items.map((item: any, idx: number) => this.renderSectionCheckbox(item, idx))}
                    <Row.Container hasOuterGutter={false} className="flex-center-v" style={{ paddingTop: '1rem' }}>
                        <Row.Column6>
                            <div className="text-muted">{__('Language')}</div>
                        </Row.Column6>
                        <Row.Column6>
                            <FieldSelect
                                items={languages}
                                value={this.state.languageId}
                                onChange={this.onLanguageChange}
                            />
                        </Row.Column6>
                    </Row.Container>
                </div>
                <div className="right">
                    {this.renderCalculations()}
                    <div className="text-muted" style={{ paddingBottom: '0.5rem', paddingTop: '1rem' }}>{__('Public price')}</div>
                    <div className="">
                        {this.renderPublicPrice()}
                    </div>
                </div>
            </div>
        )
    }

    private renderSectionCheckbox(item: any, idx: number): React.ReactNode {
        const onChange = () => {
            let selectedOutcomes = this.state.selectedOutcomes || []
            if (selectedOutcomes.includes(item.value)) {
                selectedOutcomes.splice(selectedOutcomes.indexOf(item.value), 1)
            } else {
                selectedOutcomes.push(item.value)
            }

            this.setState({
                selectedOutcomes: selectedOutcomes
            });
        };
        const checked = this.state.selectedOutcomes.includes(item.value);

        return this.renderCheckbox(item, idx, checked, onChange);
    }

    private renderPublicPrice(): React.ReactNode {
        const onChange = (event: any) => {
            this.setState({ publicPriceInclude: event.target.checked });
        }
        const idx = Math.random();
        const item = { text: __("Include"), value: idx };
        const checked = this.state.publicPriceInclude;

        return this.renderCheckbox(item, idx, checked, onChange)
    }

    private renderCheckbox(item: { text: string; value: number; }, idx: number, checked: boolean, onChange: (event: any) => void): React.ReactNode {
        const id = Math.random().toString();

        return (
            <div key={idx} style={{ padding: '4px 0' }}>
                <input id={id} type="checkbox" checked={checked} onChange={onChange} />
                <label htmlFor={id}>{item.text}</label>
            </div>
        );
    }

    private onLanguageChange = (item: any) => {
        this.setState({
            languageId: item
        });
    }

    private renderCalculations(): React.ReactNode {
        return (
            <>
                <div className="text-muted" style={{ paddingBottom: '0.5rem' }}>{__('Calculations')}</div>
                <div className="configurations">
                    {this.state.model.documentations.value.map((d: CalculationDocumentationModel) => (
                        <div key={d.calculation.id} className="configuration">
                            <input id={d.calculation.id.toString()} type="checkbox" checked={this.state.selectedDocumentations.includes(d.calculation.id)}
                                onChange={() => this.onCalculationClick(d.calculation)} />
                            <label htmlFor={d.calculation.id.toString()}>{d.calculation.name}</label>
                        </div>
                    ))}
                </div>
            </>
        );
    }

    private onCalculationClick = (calculation: TWSCalculationEditModel) => {
        this.setState(prev => ({
            selectedDocumentations: _.xor(prev.selectedDocumentations, [calculation.id])
        }));
    }

    protected override buildPostModel(calculation: TWSCalculationEditModel): GenerateDocumentationModel {
        let result = super.buildPostModel(calculation);
        result.projectId = this.props.id;
        result.documentations = this.state.model.documentations.value.filter((d: CalculationDocumentationModel) => this.state.selectedDocumentations.includes(d.calculation.id));
        result.twsOutcomes = this.state.selectedOutcomes;
        result.publicPriceInclude = this.state.publicPriceInclude;
        return result;
    }

    protected override isGenerateButtonDisabled(): boolean {
        return (this.state.selectedDocumentations?.length === 0 ?? false) || (this.state.selectedOutcomes?.length === 0 ?? false);
    }
}